import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';

const ContactFormModal = ({ clientId, contact, onClose, onSaved }) => {
  const params = useParams();
  const effectiveClientId = clientId || params.id;

  const [form, setForm] = useState({
    id: null,
    name: '',
    title: '',
    email: '',
    phone: '',
    is_primary: false
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (contact) {
      setForm({
        id: contact.id,
        name: contact.name || '',
        title: contact.title || '',
        email: contact.email || '',
        phone: contact.phone || '',
        is_primary: !!contact.is_primary
      });
      setError(null);
    } else {
      setForm({ id: null, name: '', title: '', email: '', phone: '', is_primary: false });
      setError(null);
    }
  }, [contact]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name?.trim()) return setError('Name is required');
    setSaving(true);
    try {
      if (form.id) {
        await api.put(`/clients/${effectiveClientId}/contacts/${form.id}`, form);
      } else {
        await api.post(`/clients/${effectiveClientId}/contacts`, form);
      }
      setError(null);
      if (onSaved) onSaved();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save contact');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: '40%' }}>
        <div className="modal-header">
          <h3>{form.id ? 'Edit Contact' : 'Add Contact'}</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name*</label>
            <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
          </div>
          <div className="form-group">
            <label>Title</label>
            <input value={form.title} onChange={e => setForm({...form, title: e.target.value})} />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
          </div>
          <div className="form-group">
            <label>
              <input type="checkbox" checked={form.is_primary} onChange={e => setForm({...form, is_primary: e.target.checked})} /> Is_Primary
            </label>
          </div>

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" className="cancel-btn" onClick={onClose} disabled={saving}>Cancel</button>
            <button type="submit" className="save-btn" disabled={saving}>{saving ? 'Saving...' : (form.id ? 'Update' : 'Add')}</button>
          </div>
        </form>
      </div>

      <style>{`
        .modal-overlay { position: fixed; top: 0; left: 0; right:0; bottom:0; display:flex; align-items:center; justify-content:center; background: rgba(0,0,0,0.4); z-index: 9999; }
        .modal-content { background: #fff; padding: 16px; border-radius: 6px; box-shadow: 0 6px 18px rgba(0,0,0,0.12); }
        .modal-header { display:flex; align-items:center; justify-content:space-between; }
        .close-button { font-size: 20px; background:transparent; border:none; cursor:pointer; }
        .form-group { margin-bottom: 8px; }
        .form-group label { display:block; margin-bottom: 4px; }
        .form-group input, .form-group textarea { width:100%; padding:6px 8px; }
        .error-message { color: #de350b; background-color: #ffebe6; padding: 8px; border-radius: 4px; margin-bottom: 8px; }
        .save-btn { background-color: #00875a; color: white; padding:8px 12px; border-radius:4px; }
        .cancel-btn { background-color: #f4f5f7; color: #42526e; padding:8px 12px; border-radius:4px; }
      `}</style>
    </div>
  );
};

export default ContactFormModal;
